import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from '@/store';
import { BASE_URL } from '@/utils/constants/apiEndpoints';

interface SupportContext {
  patientId?: string;
  page: string;
  timestamp: string;
  userId?: string;
  userEmail?: string;
}

interface SendSupportMessageRequest {
  patientId: string;
  message: string;
  context: SupportContext;
}

interface SendSupportMessageResponse {
  success: boolean;
  messageId?: string;
  error?: string;
}

export const supportApiSlice = createApi({
  reducerPath: 'supportApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: ['Support'],
  endpoints: (builder) => ({
    sendSupportMessage: builder.mutation<SendSupportMessageResponse, SendSupportMessageRequest>({
      query: ({ patientId, message, context }) => ({
        url: `/patients/${patientId}/support`,
        method: 'POST',
        body: {
          message,
          context
        }
      })
    })
  })
});

export const { useSendSupportMessageMutation } = supportApiSlice;
